<template>
  <div>
    <b-modal v-model="showSendSuccessModal" :width="300" scroll="keep" animation="zoom-out" :can-cancel="false">

      <div class="loading-modal">
        <header class="modal-card-head">
          <p class="modal-card-title"></p>
          <button @click="closeModal" type="button" class="delete"></button>
        </header>
        <div class="card-content" style="padding-top: 30px">
          <img  :src="require('@/assets/gifs/send-success.gif')" alt="document-send-success">
        </div>

      </div>
    </b-modal>
  </div>
</template>

<script>

export default {

  name : 'send-success',

  data (){
    return {
      showSendSuccessModal : true,
    }
  },

  methods:{

      closeModal(){
        console.log("Close document sucess modal--------------------")
        this.$emit('closeDocumentSendModal')
      },

  }
}

</script>

<style scoped>
.loading-modal{
  border-radius: 20px;
  background-color: white;
  height: 100%;
}
</style>
